{
  "source": "legacy/cdm2026_v2.html",
  "defaultTheme": "dark",
  "themes": {
    "light": {
      "--page-bg": "#faf9f5",
      "--color-background-primary": "#ffffff",
      "--color-background-secondary": "#f0eee6",
      "--color-background-warning": "#faeeda",
      "--color-background-success": "#eaf3de",
      "--color-background-info": "#b5d4f4",
      "--color-text-primary": "#1f1e1a",
      "--color-text-secondary": "#5f5e5a",
      "--color-text-tertiary": "#888780",
      "--color-text-warning": "#633806",
      "--color-text-danger": "#a32d2d",
      "--color-text-success": "#3b6d11",
      "--color-border-tertiary": "rgba(31,30,26,.15)",
      "--color-border-secondary": "rgba(31,30,26,.32)",
      "--color-border-warning": "rgba(186,117,23,.55)",
      "--border-radius-md": "8px",
      "--border-radius-lg": "12px"
    },
    "dark": {
      "--page-bg": "#21201e",
      "--color-background-primary": "#2b2a28",
      "--color-background-secondary": "#343330",
      "--color-background-warning": "#633806",
      "--color-background-success": "#27500a",
      "--color-background-info": "#185fa5",
      "--color-text-primary": "#f0efea",
      "--color-text-secondary": "#b4b2a9",
      "--color-text-tertiary": "#888780",
      "--color-text-warning": "#fac775",
      "--color-text-danger": "#f09595",
      "--color-text-success": "#97c459",
      "--color-border-tertiary": "rgba(245,244,238,.15)",
      "--color-border-secondary": "rgba(245,244,238,.32)",
      "--color-border-warning": "rgba(250,199,117,.45)"
    }
  },
  "fonts": {
    "body": "ui-sans-serif,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,sans-serif",
    "display": "'Space Grotesk',ui-sans-serif,sans-serif"
  },
  "cdn": [
    "https://cdn.jsdelivr.net/npm/flag-icons@7.2.3/css/flag-icons.min.css",
    "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@3/dist/tabler-icons.min.css",
    "https://cdn.jsdelivr.net/npm/@fontsource/space-grotesk@5/index.css",
    "https://cdn.jsdelivr.net/npm/@fontsource/space-grotesk@5/500.css"
  ],
  "background": {
    "file": "src/assets/background.webp",
    "appliedTo": "dark",
    "cssDeclarations": "background-color:#21201e;background-image:linear-gradient(rgba(33,32,30,.55),rgba(33,32,30,.32) 45%,rgba(33,32,30,.16)),url(\"<background>\");background-size:cover;background-position:center;background-repeat:no-repeat;background-attachment:fixed",
    "note": "Image appliquée uniquement au thème sombre dans le legacy, voilée par un dégradé ; pas de lignes de bracket décoratives (image déjà retouchée)."
  }
}
